export default import.meta.ROLLDOWN_FILE_URL_URGLoJmBgD1E8hzYMpiEiA